import type {StyleFunctionProps} from '@chakra-ui/styled-system';
import {defineCssVars, defineStyleConfig} from '@chakra-ui/styled-system';

export const {
  fontWeight: $fontWeight,
  fontSize: $fontSize,
  color: $color,
  minHeight: $minHeight,
} = defineCssVars(`node_heading`, [`fontSize`, `fontWeight`, `color`, `minHeight`]);

export const nodeHeadingCSSVars = ({colorMode}: StyleFunctionProps) => ({
  [$color.variable]: colorMode === `light` ? `colors.gray.600` : `colors.gray.400`,
  [$fontSize.variable]: `fontSizes.lg`,
  [$fontWeight.variable]: `fontWeights.medium`,
  [$minHeight.variable]: `1em`,
});

export const nodeHeadingStyle = defineStyleConfig({
  baseStyle: {
    // Color
    color: $color.reference,
    // Typography
    fontSize: $fontSize.reference,
    fontWeight: $fontWeight.reference,
    // Layout
    width: `full`,
    minHeight: $minHeight.reference,
  },
  sizes: {
    sm: {
      fontSize: $fontSize.reference,
    },
    md: {
      fontSize: $fontSize.reference,
    },
    lg: {
      fontSize: $fontSize.reference,
    },
  },
});
